const image = [
  {
    key: 1,
    titleDe: "Individuelle Bedarfsanalyse",
    titleEng: "Individual requirements analysis",
    contentDe:
      "Im persönlichen Gespräch analysieren wir individuell mit Dir die Stärken Deines bestehenden Leistungsangebots.",
    contentEng:
      "In a personal meeting, we analyze the strengths of your existing service offering individually with you."
  },
  {
    key: 2,
    titleDe: "Lösungsentwicklung",
    titleEng: "Solutions development",
    contentDe:
      "Mit unserem technologieoffenen Entwicklungsansatz integrieren wir in Ihre Websiteumgebung moderne Drittanbieterwerkzeuge.",
    contentEng:
      "With our technologically open development approach, we integrate modern third-party tools into your website environment."
  },
  {
    key: 3,
    titleDe: "UX/UI",
    titleEng: "UX/UI",
    contentDe:
      "Wir konzipieren ein strategisches Websitelayout und strukturieren Ihre Inhalte nutzerfreundlich für unterschiedliche Bildschirmgrößen.",
    contentEng:
      "We design a strategic website layout and structure your content in a user-friendly way for different screen sizes."
  },
  {
    key: 4,
    titleDe: "Pflege",
    titleEng: "Maintenance",
    contentDe:
      "Durch unsere Architekturexpertise stellen wir sicher, dass Ihre Architekturprojekte im besten Licht erstrahlen."
      ,
    contentEng:
      "Our architectural expertise ensures that your architectural projects are presented in the very best way."
  }
];

export default image;